
<app-card-table
    [info]="info"
    (click)="handleClick($event)"
    (scroll)="handleScroll($event)"
></app-card-table>